function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M21.5,0H2.5A2.5,2.5,0,0,0,0,2.5v14A2.5,2.5,0,0,0,2.5,19h19A2.5,2.5,0,0,0,24,16.5V2.5A2.5,2.5,0,0,0,21.5,0ZM23,16.5A1.5,1.5,0,0,1,21.5,18H2.5A1.5,1.5,0,0,1,1,16.5V6H23ZM23,5H1V2.5A1.5,1.5,0,0,1,2.5,1h19A1.5,1.5,0,0,1,23,2.5ZM4,2A1,1,0,1,0,5,3,1,1,0,0,0,4,2ZM7,2A1,1,0,1,0,8,3,1,1,0,0,0,7,2Zm3,0a1,1,0,1,0,1,1A1,1,0,0,0,10,2ZM5.15,14.15,7.29,12,5.15,9.85a.49.49,0,0,1,.7-.7l2.5,2.5a.48.48,0,0,1,0,.7l-2.5,2.5a.48.48,0,0,1-.7,0A.48.48,0,0,1,5.15,14.15ZM11,12.5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,0,1h-4A.5.5,0,0,1,11,12.5Z"
})));

var SvgTechScreen = function SvgTechScreen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 19",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTechScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tech-screen.13813ebd.svg";
export { ForwardRef as ReactComponent };